import type { AccessorialUnit, RateLineProposalKind, RateLineProposalStatus } from '@chukua/common';

export const PROPOSAL_STATUS_LABELS: Record<RateLineProposalStatus, string> = {
  draft: 'Draft',
  pending_approval: 'Pending approval',
  approved: 'Approved',
  withdrawn: 'Withdrawn',
};

export const PROPOSAL_KIND_LABELS: Record<RateLineProposalKind, string> = { create: 'New line', supersede: 'Price change' };

export const ACCESSORIAL_UNIT_LABELS: Record<AccessorialUnit, string> = { per_hour: 'Per hour', per_day: 'Per day', per_event: 'Per event' };
